import { lazy } from 'react';

const Enem365LoginPage = lazy(() => import('../pages/LoginPage'));
const Enem365HomePage = lazy(() => import('../pages/Home'));
const Enem365SisuPage = lazy(() => import('../pages/Sisu'));
const Enem365ExamPage = lazy(() => import('../pages/Exam'));
const Enem365FeedbackPage = lazy(() => import('../pages/Feedback'));

export const Enem365Routes = [
  {
    path: '/enem-365/login',
    element: <Enem365LoginPage />,
  },
  {
    path: '/enem-365',
    element: <Enem365HomePage />,
  },
  {
    path: '/enem-365/sisu',
    element: <Enem365SisuPage />,
  },
  {
    path: '/enem-365/prova/:day',
    element: <Enem365ExamPage />,
  },
  {
    path: '/enem-365/gabarito/:day',
    element: <Enem365FeedbackPage />,
  },
];
